import analytics from './analytics.js'

const observers = new WeakMap()
export default {
	inserted(element, binding) {
		if (typeof IntersectionObserver === 'undefined') return
		const state = { value: binding.value, seen: new Set(), timer: null, observer: null }
		state.observer = new IntersectionObserver(entries => {
			entries.forEach(entry => {
				clearTimeout(state.timer)
				if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return
				state.timer = setTimeout(() => {
					const value = state.value || {}
					const key = `${value.event}:${value.key}`
					if (document.visibilityState === 'hidden' || state.seen.has(key)) return
					if (analytics.track(value.event, { ...value.properties, exposure_rule: 'visible_50pct_500ms' })) state.seen.add(key)
				}, 500)
			})
		}, { threshold: [0, 0.5] })
		state.observer.observe(element)
		observers.set(element, state)
	},
	update(element, binding) {
		const state = observers.get(element)
		if (state) state.value = binding.value
	},
	unbind(element) {
		const state = observers.get(element)
		if (state) { clearTimeout(state.timer); state.observer.disconnect(); observers.delete(element) }
	}
}
